import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Card, CardBody, CardHeader, Button } from 'reactstrap'

import CustomSwitch from '../../CustomSwitch'
import CustomSelect from '../../CustomReactSelectComponent'

const FiltersTimeline = ({ onChangeSwitches, values, selectValues, onChangeSelect, onSearchClick }) => {
  return (
    <Card>
      <CardHeader>Filters</CardHeader>
      <CardBody>
        <Row className='mt-2 d-flex align-items-end'>
          <Col md={2}>
            <CustomSwitch
              onChange={onChangeSwitches}
              checked={values.allActivities}
              name='allActivities'
              label='View All Activities'
            />
          </Col>
          <Col md={2}>
            <CustomSwitch
              onChange={onChangeSwitches}
              checked={values.activities}
              name='activities'
              label='View Activities'
            />
          </Col>
          <Col md={2}>
            <CustomSwitch
              onChange={onChangeSwitches}
              checked={values.myActivities}
              name='myActivities'
              label='View My Activities'
            />
          </Col>
          <Col md={2}>
            <CustomSwitch
              onChange={onChangeSwitches}
              checked={values.myTeamActivities}
              name='myTeamActivities'
              label='View My Team Activities'
            />
          </Col>
          <Col md={3}>
            <CustomSelect
              onChange={onChangeSelect}
              defaultValue={values.division}
              name='division'
              label='Select Division To View Their Activities'
              options={selectValues.divisionOptions}
              isClearable={true}
              isMulti={true}
            />
          </Col>
          <Col md='3'>
            <CustomSelect
              onChange={onChangeSelect}
              defaultValue={values.activityType}
              name='activityType'
              label='Activity Type'
              options={selectValues.activityTypeOptions}
              isClearable={true}
              isMulti={true}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col>
            <Button size='sm' className='float-right gold-color-button' onClick={onSearchClick}>
              Search
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

FiltersTimeline.propTypes = {
  onChangeSwitches: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  selectValues: PropTypes.object.isRequired,
  onChangeSelect: PropTypes.func.isRequired,
  onSearchClick: PropTypes.func.isRequired,
}

export default FiltersTimeline
